module.exports = __webpack_public_path__ + "img/thumbnail-side-by-side-calyrafit.5b8dbb88.webp";